import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import { store } from '@/store/index';
import i18n from '@/i18n';
import Vuelidate from 'vuelidate';
import VueClipboard from 'vue-clipboard2';
import { sync } from 'vuex-router-sync';
import '@/plugins/filter';
// import './registerServiceWorker';
import { CoolSelectPlugin } from 'vue-cool-select'
import 'vue-cool-select/dist/themes/bootstrap.css'
import { cookieService } from '@/service/cookie.service';

//iView===============================================================
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

//Echart===============================================================
import ECharts from 'vue-echarts/components/ECharts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/custom';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/chart/graph';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/chart/radar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/dataZoom';

import iviewEN from 'view-design/dist/locale/en-US';
import iviewVI from 'view-design/dist/locale/vi-VN';
import iviewJA from 'view-design/dist/locale/ja-JP';

let locale: any;
//const langCode: string = 'ja';
const langCode: string = cookieService.language || 'ja';
cookieService.language = langCode;
switch (langCode) {
  case 'ja': {
    const fixDatepicker = iviewJA.i.datepicker;
    fixDatepicker.clear = 'クリア';
    fixDatepicker.selectDate = '日付選択';
    fixDatepicker.selectTime = '時間選択';
    locale = iviewJA;
    break;
  }
  case 'en': {
    locale = iviewEN;
    break;
  }
  case 'vi': {
    locale = iviewVI;
    break;
  }
}

// (function log4Setting() {
//   console.log(`Your are running: %c${process.env.NODE_ENV}`, 'color:blue', 'mode');
//   if (process.env.NODE_ENV != 'prodcution') {
//     console.log(`API Endpoint: ${process.env.VUE_APP_API_ENDPOINT}`);
//     console.log(`Cookie Timeout: ${process.env.VUE_APP_COOKIE_TIMEOUT}H`);
//   }
// })();

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;
Vue.use(Vuelidate);
Vue.use(ViewUI, { locale });
Vue.component('v-chart', ECharts);
Vue.use(VueClipboard);
Vue.use(CoolSelectPlugin)

// It'll lost vuex stored value when refresh browser and therefor restore value from cookie
store.dispatch('loadSettings');

// syncronize Store and Router
sync(store, router);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
